/**
 * Single source of truth for the version the API reports. Kept in sync with the root
 * package.json by `version.test.ts` — a drift there fails the test suite, not production.
 */
export const APP_VERSION = '0.1.0'

export const APP_NAME = 'kontor'
